var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: [_vm.namespace(), _vm.skinStyle] }, [
    _c(
      "div",
      {
        class: [
          _vm.mdsNS("form__select form__select--small"),
          _vm.namespace("wrap")
        ]
      },
      [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            class: [
              _vm.mdsNS("form__select-input"),
              _vm.namespace("wrap-input")
            ],
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.value = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.change
              ]
            }
          },
          _vm._l(_vm.dataModel, function(item) {
            return _c(
              "option",
              {
                key: item.id,
                class: [
                  _vm.mdsNS("form__select-option"),
                  _vm.namespace("wrap-option")
                ],
                domProps: { value: item.id, selected: item.selected }
              },
              [
                _vm._v(
                  "\n                " + _vm._s(item.name) + "\n            "
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { class: _vm.mdsNS("form__select-visual-wrap") }),
        _vm._v(" "),
        _c("span", { class: _vm.mdsNS("form__select-open-indicator") }, [
          _c(
            "svg",
            {
              class: _vm.mdsNS("icon form__select-open-icon"),
              attrs: { "aria-hidden": "true" }
            },
            [_c("use", { attrs: { "xlink:href": "#caret-down--s" } })]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }